import React from 'react';

import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';

import { NavigationHeader } from 'components/Settings/Components/Opc/NavigationHeader/NavigationHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { OpcView } from 'components/pages/OpcViewPage/components/OpcVIew/OpcView';

export const OpcViewPage = () => {
    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <NavigationHeader
                        pageTitle={'Oracle Primavera Cloud'}
                        items={[
                            {
                                label: 'Integrations',
                                to: AppRoutes.buildPath(AppRoutes.SETTINGS, settingsConfig.integrations.link),
                                noEllipsis: true,
                            },
                            {
                                label: 'Oracle Primavera Cloud',
                                noEllipsis: true,
                            },
                        ]}
                    />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <OpcView />
            </MainContent>
        </PageContainer>
    );
};
